import {useNavigate, useSearchParams} from "react-router-dom";
import Logo from "../../../assets/images/Logo.png";
import routeConstant from "../../../utils/routeConstant";
import {
    Container,
    NavActions,
    Navigation,
    PrimaryButton,
    NavMenuItem,
    BrandLogo,
    NavAnchorLink,
} from "./style";

const LandingNavbar = () => {
    const navigate = useNavigate();
    const [searchParms] = useSearchParams();
    const stringifySearchParams = searchParms.toString();

    return (
        <Container>
            <Navigation>
                <BrandLogo src={Logo} alt="brand-logo"/>
                <NavAnchorLink href="#services">Services</NavAnchorLink>
                <NavAnchorLink href="#about-platform">About Platform</NavAnchorLink>
            </Navigation>
            <NavActions>
                <NavMenuItem to={`/${routeConstant.login}${stringifySearchParams ? "?" + stringifySearchParams : ""}`}>Log
                    in</NavMenuItem>
                <PrimaryButton onClick={() => navigate(`/${routeConstant.signup}${stringifySearchParams ? "?" + stringifySearchParams : ""}`)}>
                    Get Started
                </PrimaryButton>
            </NavActions>
        </Container>
    );
};

export default LandingNavbar;
